import { render } from "./RaceEthnicity.vue?vue&type=template&id=7abfe614&ts=true"
import script from "./RaceEthnicity.ts?vue&type=script&lang=ts&external"
export * from "./RaceEthnicity.ts?vue&type=script&lang=ts&external"

import "./RaceEthnicity.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__